import React from "react";

export function formatarDuracao(hms) {
  if (!hms || typeof hms !== "string") return "—";
  const parts = hms.split(":");
  if (parts.length !== 3) return hms;
  const h = parseInt(parts[0], 10) || 0;
  const m = parseInt(parts[1], 10) || 0;
  const s = Math.floor(parseFloat(parts[2])) || 0;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

export function formatarDataHora(data) {
  if (!data) return "—";
  return new Date(data).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "America/Sao_Paulo",
  });
}

export function formatarData(data) {
  if (!data) return "—";
  return new Date(data).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "America/Sao_Paulo",
  });
}

export function statusConfig(status) {
  switch (status) {
    case "Succeeded":
      return {
        label: "Sucesso",
        badgeClass: "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200",
        dotClass: "bg-emerald-500",
        iconBg: "bg-emerald-100",
        iconColor: "text-emerald-600",
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
          </svg>
        ),
      };
    case "Failed":
      return {
        label: "Falha",
        badgeClass: "bg-red-50 text-red-700 ring-1 ring-red-200",
        dotClass: "bg-red-500",
        iconBg: "bg-red-100",
        iconColor: "text-red-600",
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ),
      };
    case "Running":
      return {
        label: "Em execução",
        badgeClass: "bg-violet-50 text-violet-700 ring-1 ring-violet-200",
        dotClass: "bg-violet-500 animate-pulse",
        iconBg: "bg-violet-100",
        iconColor: "text-violet-600",
        icon: (
          <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
          </svg>
        ),
      };
    case "Pending":
      return {
        label: "Pendente",
        badgeClass: "bg-amber-50 text-amber-700 ring-1 ring-amber-200",
        dotClass: "bg-amber-500",
        iconBg: "bg-amber-100",
        iconColor: "text-amber-600",
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ),
      };
    case "Queued":
      return {
        label: "Agendado",
        badgeClass: "bg-indigo-50 text-indigo-700 ring-1 ring-indigo-200",
        dotClass: "bg-indigo-500",
        iconBg: "bg-indigo-100",
        iconColor: "text-indigo-600",
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        ),
      };
    case "Cancelled":
      return {
        label: "Cancelado",
        badgeClass: "bg-slate-100 text-slate-600 ring-1 ring-slate-200",
        dotClass: "bg-slate-400",
        iconBg: "bg-slate-100",
        iconColor: "text-slate-500",
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728A9 9 0 015.636 5.636" />
          </svg>
        ),
      };
    default:
      return {
        label: status || "—",
        badgeClass: "bg-slate-100 text-slate-600 ring-1 ring-slate-200",
        dotClass: "bg-slate-400",
        iconBg: "bg-slate-100",
        iconColor: "text-slate-500",
        icon: (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ),
      };
  }
}
